import * as S from './SalesCategory.style';
const categories = [
    { label: '전체 매출', value: 'all' },
    { label: '시놀 매출', value: 'sinor' },
    { label: '시럽 매출', value: 'silove' },
];
export default function SalesCategory({ currentCategory, selectCategory }) {
    return (
        <S.SalesCategoryContainer>
            {categories.map((category) => (
                <S.CategoryButton key={category.value} onClick={() => selectCategory(category.value)} $isSelected={currentCategory === category.value}>
                    {category.label}
                </S.CategoryButton>
            ))}
        </S.SalesCategoryContainer>
    );
}
